// packages/utils/src/shared/urls/stripUrlFragment.ts

/**
 * The URL without its `#fragment`: the substring before the first `#`, or the
 * input when it has none. For anything that leaves the browser (telemetry, logs),
 * since capability-link and booking tokens live in the fragment.
 */
export function stripUrlFragment(url: string): string {
  const hashIndex = url.indexOf('#');
  return hashIndex === -1 ? url : url.slice(0, hashIndex);
}
